import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Refreshes the shipping estimate when the selected variant changes: the tier
 * depends on the variant weight. Reuses the section HTML Horizon already fetches
 * for the new variant (same pattern as product-inventory), so no extra request.
 */
class FredShippingEstimate extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newEstimate = html.querySelector(`fred-shipping-estimate[data-block-id="${this.dataset.blockId}"]`);
        if (!newEstimate) return;

        morph(this, newEstimate, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[fred-shipping-estimate] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('fred-shipping-estimate')) {
  customElements.define('fred-shipping-estimate', FredShippingEstimate);
}
